/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * An error due to the client not being authorized to access the resource
due to not having delegated sufficient OAuth scopes from Roblox.
 * @export
 * @interface MissingRequiredRobloxOAuthScopesResponseContent
 */
export interface MissingRequiredRobloxOAuthScopesResponseContent {
    /**
     * Message with details about the error
     * @type {string}
     * @memberof MissingRequiredRobloxOAuthScopesResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the MissingRequiredRobloxOAuthScopesResponseContent interface.
 */
export function instanceOfMissingRequiredRobloxOAuthScopesResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function MissingRequiredRobloxOAuthScopesResponseContentFromJSON(json: any): MissingRequiredRobloxOAuthScopesResponseContent {
    return MissingRequiredRobloxOAuthScopesResponseContentFromJSONTyped(json, false);
}

export function MissingRequiredRobloxOAuthScopesResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingRequiredRobloxOAuthScopesResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function MissingRequiredRobloxOAuthScopesResponseContentToJSON(value?: MissingRequiredRobloxOAuthScopesResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

